"use client";

import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const SHOW_AFTER_PX = 600;

/** "Zurück nach oben"-Sprungmarke (backlog.md -> "Konsistenz/Politur" -> "'Zurück nach
 * oben'/Sprungmarken-Navigation auf allen langen Seiten") - erscheint erst nach
 * spürbarem Herunterscrollen, damit sie auf kurzen Seiten nie im Weg steht. Reiner
 * `scroll`-Event-Listener statt IntersectionObserver, bewusst (siehe
 * feedback_browser_testing_flush-Memory, neunte Variante: IntersectionObserver-Callbacks
 * koennen in manchen Tab-Zustaenden komplett ausbleiben, waehrend scroll-Events
 * zuverlaessig blieben). */
export function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > SHOW_AFTER_PX);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Button
      type="button"
      variant="secondary"
      size="icon-lg"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Nach oben scrollen"
      className={cn(
        "fixed bottom-6 right-4 z-40 rounded-full border border-hairline shadow-lg transition-opacity duration-200 md:right-6",
        visible ? "opacity-100" : "pointer-events-none opacity-0",
      )}
    >
      <ArrowUp className="h-4 w-4" aria-hidden="true" />
    </Button>
  );
}
